export const environment = {
  authApiBaseUrl: 'https://auth.dev.earthon.ai'
};
